import { render, staticRenderFns } from "./VirtualServiceAccountSummary.vue?vue&type=template&id=47b887b3&scoped=true&"
import script from "./VirtualServiceAccountSummary.vue?vue&type=script&lang=js&"
export * from "./VirtualServiceAccountSummary.vue?vue&type=script&lang=js&"
import style0 from "./VirtualServiceAccountSummary.vue?vue&type=style&index=0&id=47b887b3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b887b3",
  null
  
)

export default component.exports